import React from 'react';

import { scssVariables as variables } from 'src/helpers';

const LoginLTIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={'100%'}
    height={'100%'}
    viewBox='0 0 480 450.651'
  >
    <defs>
      <filter id='Ellipse_1' x='152' y='199' width='175' height='175' filterUnits='userSpaceOnUse'>
        <feOffset in='SourceAlpha' />
        <feGaussianBlur stdDeviation='5' result='blur' />
        <feFlood floodOpacity='0.078' />
        <feComposite operator='in' in2='blur' />
        <feComposite in='SourceGraphic' />
      </filter>
    </defs>
    <g id='Group_2' data-name='Group 2' transform='translate(0)'>
      <path
        id='Intersection_1'
        data-name='Intersection 1'
        d='M0,0H480V189.374S425.118,306.388,248.606,287.93C81.629,270.468,7.519,433.037,0,450.651Z'
        transform='translate(0)'
        fill={variables['colors-mc-logo-1']}
      />
    </g>
    <g transform='matrix(1, 0, 0, 1, 0, 0)' filter='url(#Ellipse_1)'>
      <circle
        id='Ellipse_1-2'
        data-name='Ellipse 1'
        cx='72.5'
        cy='72.5'
        r='72.5'
        transform='translate(167 214)'
        fill='#fff'
      />
    </g>
    <g id='logo' transform='translate(208 254.214)'>
      <path
        id='Path_2'
        data-name='Path 2'
        d='M31.909,63.817h-30l7.228-9.557a31.908,31.908,0,1,1,22.771,9.557Z'
        transform='translate(0 -0.214)'
        fill={variables['colors-mc-logo-2']}
      />
      <path
        id='Path_3'
        data-name='Path 3'
        d='M256,0V63.818A31.909,31.909,0,1,0,256,0Z'
        transform='translate(-223.909 0.065)'
        fill={variables['colors-mc-logo-1']}
      />
      <g id='plus' transform='translate(19.328 19.21)'>
        <path
          id='Path_5'
          data-name='Path 5'
          d='M191.212,206.527h5.105V196.316h10.211v-5.106H196.317V181h-5.105v10.211H181v5.106h10.211Z'
          transform='translate(-181.001 -181)'
          fill='#fff'
        />
      </g>
    </g>
  </svg>
);

export default LoginLTIcon;
